import success from '../Assets/Image/success.gif';

function CustomMessage({ status }) {
  return (
    <div className='bg-p-wh px-6 flex flex-row items-center py-6 rounded-lg top-28 drop-shadow-lg'>
      <img src={success} alt='success' className='w-20' />
      <p className='text-green-500 font-semibold'>
        You have successfully {status === 'placed' ? 'placed' : 'updated'} an
        offer
      </p>
    </div>
  );
}

export default CustomMessage;
